import Box from '@mui/material/Box';

import logoAlmacenesAgiles from '../../assets/images/logo-almacenes-agiles.png';

function Logo() {
  return (
    <Box
      component="img"
      sx={{
        height: 48,
      }}
      alt="Almacenes Ágiles"
      src={logoAlmacenesAgiles}
    />
  );
}

export default Logo;
